module.exports = __webpack_public_path__ + "img/KUCE-05.81adc621.png";